import * as yup from 'yup';
import { es as yupEs } from 'yup-locales';

export const esLocale = {
  mixed: {
    default: '${path} no es válido',
    required: '${path} es requerido',
    oneOf: '${path} debe ser uno de los siguientes valores: ${values}',
    notOneOf: '${path} no debe ser uno de los siguientes valores: ${values}',
    notType: '${path} debe ser de tipo ${type}',
  },
  string: {
    length: '${path} debe tener exactamente ${length} caracteres',
    min: '${path} debe tener al menos ${min} caracteres',
    max: '${path} debe tener máximo ${max} caracteres',
    matches: '${path} debe coincidir con el formato requerido',
    email: '${path} debe ser un correo electrónico válido',
    url: '${path} debe ser una URL válida',
    trim: '${path} no debe contener espacios al inicio o al final',
    lowercase: '${path} debe estar en minúsculas',
    uppercase: '${path} debe estar en mayúsculas',
  },
  number: {
    min: '${path} debe ser mayor o igual a ${min}',
    max: '${path} debe ser menor o igual a ${max}',
    lessThan: '${path} debe ser menor que ${less}',
    moreThan: '${path} debe ser mayor que ${more}',
    positive: '${path} debe ser un número positivo',
    negative: '${path} debe ser un número negativo',
    integer: '${path} debe ser un número entero',
  },
  date: {
    min: '${path} debe ser posterior a ${min}',
    max: '${path} debe ser anterior a ${max}',
  },
  array: {
    min: '${path} debe tener al menos ${min} elementos',
    max: '${path} debe tener máximo ${max} elementos',
  },
};

export const setYupLocales = () => {
  yup.setLocale(yupEs);
  yup.setLocale(esLocale);
};
